/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _action_types = require('../../action_types');

var _product_utils = require('../../utils/product_utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function productListToSet(state, action) {
    var nextState = _extends({}, state);
    action.data.forEach(function (product) {
        var nextSet = new Set(nextState[product.team_id]);
        nextSet.add(product.id);
        nextState[product.team_id] = nextSet;
    });

    return nextState;
}

function removeProductFromSet(state, action) {
    var id = action.data.team_id;
    var nextSet = new Set(state[id]);
    nextSet.delete(action.data.id);
    return _extends({}, state, _defineProperty({}, id, nextSet));
}

function products() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ProductTypes.RECEIVED_PRODUCT:
            return addProductToSet(state, action);
        case _action_types.ProductTypes.PRODUCT_DELETED:
            var nextState = _extends({}, state);
            Reflect.deleteProperty(nextState, action.data.id);
            return nextState;
        case _action_types.ProductTypes.RECEIVED_PRODUCTS_LIST:
            return Object.assign({}, state, (0, _product_utils.productListToMap)(action.data));
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function productsInTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ProductTypes.PRODUCT_DELETED:
            return removeProductFromSet(state, action);
        case _action_types.ProductTypes.RECEIVED_PRODUCTS_LIST_IN_TEAM:
            return productListToSet(state, action);
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function addProductToSet(state, action) {
    var id = action.id;
    var nextSet = new Set(state[id]);
    nextSet.add(action.data.product_id);
    return _extends({}, state, _defineProperty({}, id, nextSet));
}

exports.default = (0, _redux.combineReducers)({
    products: products,
    productsInTeam: productsInTeam
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/mattermost-redux/reducers/entities/products.js
// module id = 1024
// module chunks = 76